<template>
  <div class="changephone">
    <van-nav-bar placeholder title="修改手机号" left-text="" left-arrow @click-left="onClickLeft()">
      <template #right>
      </template>
    </van-nav-bar>
    <div class="phone-box">
      <h2>修改手机号</h2>
      <p class="oldphone">旧手机号码：{{mobile}}</p>
      <van-form @submit="onSubmit">
        <van-field
                v-model="form.code"
                center
                :clearable="false"
                label="验证码"
                placeholder="请输入"
        >
          <template #button>
            <span @click="getCode(mobile, 'yzm')">{{yzm.buttonName}}</span>
          </template>
        </van-field>
        <van-field
                v-model="form.newMobile"
                name="mobile"
                label="新手机号码"
                maxlength="11"
                placeholder="请输入"
                :clearable="false"
        />
        <van-field
                v-model="form.newMobileCode"
                center
                :clearable="false"
                label="短信验证码"
                placeholder="请输入验证码"
        >
          <template #button>
            <span @click="getCode(form.newMobile, 'yzm2')">{{yzm2.buttonName}}</span>
          </template>
        </van-field>
        <van-button :loading="formLoading" round block type="info" native-type="submit" class="phonebox">确定</van-button>
      </van-form>
    </div>
  </div>
</template>

<script>
  import {getSmsCaptcha, changePhone} from '@/api/login'
  export default {
    name: 'changePhone',
    data() {
      return {
        form: {},
        yzm: {
          cansend: true,
          buttonName: '发送验证码',
          timeCount: 60,
          timer: undefined
        },
        yzm2: {
          cansend: true,
          buttonName: '发送验证码',
          timeCount: 60,
          timer: undefined
        },
        formLoading: false,
      }
    },
    computed: {
      mobile () {
        return this.$store.getters.userInfo.mmobileNum
      }
    },
    mounted() {
    },
    methods: {
      onClickLeft() {
        this.$router.go(-1)
      },
      isMobile(mobile) {
        if (!mobile) return false;
        return /^1[3-9]\d{9}$/.test(mobile);
      },
      getCode(mobile, key) {
        if (!mobile) {
          this.$toast('请输入手机号')
          return
        }
        if (!this.isMobile(mobile)) {
          this.$toast('请输入正确手机号')
          return
        }
        if (this[key].cansend) {
          const data = {
            mobile: mobile
          }
          getSmsCaptcha(data).then(res => {
            if (res.code === 10000) {
              this.$toast('发送成功')
              this.timerHandel(key)
            }
          })
        }
      },
      timerHandel(key) {
        const that = this
        const timeCount = 60
        that[key].cansend = false
        that[key].timeCount = timeCount
        that[key].timer = setInterval(() => {
          if (that[key].timeCount > 0 && that[key].timeCount <= timeCount) {
            that[key].timeCount--
            that[key].buttonName = that[key].timeCount + 's'
          } else {
            that[key].cansend = true
            clearInterval(that[key].timer)
            that[key].timer = null
            that[key].buttonName = '获取验证码'
          }
        }, 1000)
      },
      onSubmit() {
        if (!this.form.newMobile) {
          this.$toast('请输入手机号')
          return
        }
        if (!this.isMobile(this.form.newMobile)) {
          this.$toast('请输入正确手机号')
          return
        }
        if (!this.form.code) {
          this.$toast('请输入旧手机验证码')
          return
        }
        if (!this.form.newMobileCode) {
          this.$toast('请输入新手机验证码')
          return
        }
        this.formLoading = true
        changePhone(this.form).then(res => {
          if (res.code === 10000) {
            this.$toast(res.msg)
            // 重新加载用户信息
            this.$store.dispatch('GetInfo').catch(() => {})
            this.$router.go(-1)
          }
        }).finally(() => {
          this.formLoading = false
        })
      }
    }
  }
</script>

<style scoped>
.phonebox {
  display: flex;
  padding: 10px;
  background: url("~@/assets/button-style.png") 8px 10px no-repeat #66C779;
  background-size: 11px 15px;
  border-radius: 25px;
  align-items: center;
  justify-content: center;
  height:52px;
  border: none;
  font-size:18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #FFFFFF;
}
.changephone{
  padding: 0;
  display: flex;
  height: 100vh;
  display: flex;
  flex-direction: column;
}
.phone-box{
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 27px;
  flex-direction: column;
  height:70vh;
}
.changephone h2{
  display: flex;
  align-items: center;
  font-size:24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  margin-bottom:18px;
}
.oldphone{
  display: flex;
  height:16px;
  font-size:16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  margin-bottom: 22px;
}
/deep/.van-cell::after{
  border: none;
}
/deep/.van-cell{
  height:46px;
  background: #F4F5F7;
  border-radius:100px;
  display: flex;
  align-items: center;
  margin-bottom:18px;
}
.van-field__button span{
  font-size:14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #66C779;
}
</style>
